import { useMediaQuery as MUIuseMediaQuery } from '@mui/material';

export const useMediaQuery = MUIuseMediaQuery;
